import { createModulePage } from '../../../components/generic/createModulePage';
import { initializeModule } from '../../../utils/configInit';
import { employeeConfig } from './employeeConfig';
import { createEmployeeValidation } from './employeeValidation';

/**
 * Initialize the Employee module using generic utilities
 */
const { config: initializedConfig } = initializeModule(
  employeeConfig,
  createEmployeeValidation
);

/**
 * Create the EmployeePage using the generic module page factory
 */
const EmployeePage = createModulePage(
  initializedConfig,
  {
    displayName: 'EmployeePage',
    description: 'Employee Management System - Manage employees for training assignments'
  }
);

export default EmployeePage;

